import { createReducer } from '@reduxjs/toolkit';
import { getDiagnosticPage, getDiagnosticPageStaff } from '../actions/diagnosticPage';

const initialState = {
  loading: true,
  staffLoading: true,
  data: {},
  staff: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getDiagnosticPage.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  })).addCase(getDiagnosticPageStaff.fulfilled, (state, action) => ({
    ...state,
    staff: action.payload,
    staffLoading: false,
  }));
});
